// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Timelines
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { heroEntry } from "./animations/heroEntry";
import { infoItems } from "./animations/infoItems";
import { serviceItems } from "./animations/serviceItems";
import { virtualOfficeCta } from "./animations/virtualOfficeCta";
import { projectCards } from "./animations/projectCards";

/*
//import { timeline } from "./timeline";
//import { abstractBg } from "./abstractBg";
import { virtualOfficeCta } from "./virtualOfficeCta";
import { projectCards } from "./projectCards";

import { infoItems } from "./infoItems";
import { expandingImage } from "./expandingImage";
import { serviceItems } from "./serviceItems";
*/

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

function homepageAnimations(showMarkers, scrollAnimation) {

  var homeAnimations = gsap.timeline({
    paused: true,
    trigger: ".homepage-trigger",
    start: "top top",
    end: "bottom bottom",
    //pin: sectionElement,
    //pinReparent: false,
    markers: showMarkers,
    //scrub: true,
    id: "homepage-animations",
  });

  var topHero = document.querySelector(".top-hero-section");
  var infoSection = document.querySelector(".info-items-section");
  var midHero = document.querySelector(".mid-page-hero");
  var serviceSection = document.querySelector(".services-section");
  var officeSection = document.querySelector(".home-office-cta-section");
  var quoteHero = document.querySelector(".home-quote-hero");

  homeAnimations
    .add(heroEntry(showMarkers, topHero), 0)
    .add(infoItems(showMarkers, infoSection), 0)
    .add(heroEntry(showMarkers, midHero), 0)
    .add(serviceItems(showMarkers, serviceSection), 0)
    .add(virtualOfficeCta(showMarkers, officeSection), 0)
    .add(projectCards(showMarkers), 0)
    .add(heroEntry(showMarkers, quoteHero), 1);

}

export { homepageAnimations };
